<div class="grid" *ngIf="carInformacionInicial">
  <div class="col-12 md:col-12 lg:col-12 text-center">
    <i class="fa fa-refresh fa-spin fa-3x fa-fw"></i><br>
    <span>{{'LBL_PROCESANDO' | translate }}</span>
  </div>
</div>
<div *ngIf="!carInformacionInicial">
  <p-panel header="{{ 'PRODUCTOMONTO.LBL_MONTOS' | translate}}">
    <form [formGroup]="formulario" (ngSubmit)="onSubmit()" novalidate id="fFormularioMonto" name="nomFormularioMonto">
      <div class="grid form-group">
        <div class="col-12 md:col-4 lg:col-4">
          <div class="div-form">
            <label>* {{ 'PRODUCTOMONTO.LBL_MONTOMINIMO' | translate }} ({{ 'LBL_SMLV' | translate }})</label>
            <label class="falso-combo-texto">{{f.montoMinimo.value}}</label>
            <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.montoMinimo.invalid">
              {{ 'PRODUCTOMONTO.LBL_MONTOMINIMO' | translate}} {{ 'LBL_REQUERIDO' | translate}}
            </div>
            <div class="p-message p-messages-error p-corner-all" *ngIf="ranIncorrecto">
              {{ 'LBL_RANGOINVALIDO' | translate}}
            </div>
          </div>
        </div>
        <div class="col-12 md:col-4 lg:col-4">
          <div class="div-form">
            <label>* {{ 'PRODUCTOMONTO.LBL_MONTOMAXIMO' | translate }} ({{ 'LBL_SMLV' | translate }})</label>
            <input type="text" pInputText id="idMontoMaximo"
                   name="nomMontoMaximo"
                   autocomplete="off"
                   formControlName="montoMaximo" numero-decimal-reactive [decimales]="6" [minimo]="0" [entero]="7"
                   [maxlength]="14"
            >
            <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.montoMaximo.invalid">
              {{ 'PRODUCTOMONTO.LBL_MONTOMAXIMO' | translate}} {{ 'LBL_REQUERIDO' | translate}}
            </div>
            <div class="p-message p-messages-error p-corner-all" *ngIf="ranIncorrecto">
              {{ 'LBL_RANGOINVALIDO' | translate}}
            </div>
          </div>
        </div>
        <div class="col-12 md:col-4 lg:col-4">
          <div class="div-form">
            <label>* {{ 'PRODUCTOMONTO.LBL_PLAZOMAXIMO' | translate }}</label>
            <input type="text" pInputText id="idPlazoMaximo"
                   name="nomPlazoMaximo"
                   autocomplete="off"
                   formControlName="plazoMaximo"
                   [maxlength]="3"
                   numero-entero-reactive
            >
            <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.plazoMaximo.invalid">
              {{ 'PRODUCTOMONTO.LBL_PLAZOMAXIMO' | translate}} {{ 'LBL_REQUERIDO' | translate}}
            </div>
            <div class="p-message p-messages-error p-corner-all" *ngIf="rangoPlazoIncorrecto">
              {{ 'LBL_RANGOINVALIDO' | translate}}
            </div>
          </div>
        </div>
      </div>

      <div class="grid form-group">
        <div class="col-12 md:col-4 lg:col-4">
          <div class="div-form">
            <p-checkbox binary="true" id="indicadorAnalizamos" name="indicadorAnalizamos"
                        label="{{ 'PRODUCTOMONTO.LBL_INDICADORANALIZAMOS' | translate}}"
                        (onChange)="cambioIndicador(true)"
                        formControlName="indicadorAnalizamos"></p-checkbox>
            <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && !exiIndicador" style="display: block; padding: 0px;">
              {{ 'PRODUCTOMONTO.MSG_SELECCIONEINDICADOR' | translate}}
            </div>
          </div>
        </div>
        <div class="col-12 md:col-4 lg:col-4">
          <div class="div-form">
            <p-checkbox binary="true" id="indicadorFlujoDigital" name="indicadorFlujoDigital"
                        label="{{ 'PRODUCTOMONTO.LBL_INDICADORDIGITAL' | translate}}"
                        (onChange)="cambioIndicador(false)"
                        formControlName="indicadorFlujoDigital"></p-checkbox>
          </div>
        </div>
        <div class="col-12 md:col-4 lg:col-4">
          <div class="div-form">
            <p-checkbox binary="true" id="indicadorGarantiaIdonea" name="indicadorGarantiaIdonea"
                        label="{{ 'PRODUCTOMONTO.LBL_GARANTIAIDONEA' | translate}}"
                        (onChange)="cambioGarantia($event)"
                        formControlName="indicadorGarantiaIdonea"></p-checkbox>
          </div>
        </div>
      </div>


      <div class="grid form-group">
        <div class="col-12 md:col-4 lg:col-4" *ngIf="f.indicadorGarantiaIdonea.value">
          <div class="div-form">
            <label>* {{ 'PRODUCTOMONTO.LBL_PLAXOMAXIMOGARANTIAMESES' | translate }}</label>
            <input type="text" pInputText id="idPlazoMaximoGarantiaIdonea"
                   name="nomPlazoMaximoGarantiaIdonea"
                   autocomplete="off" [minimo]="1"
                   formControlName="plazoMaximoGarantiaIdonea"
                   [maxlength]="3"
                   numero-entero-reactive
            >
            <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.plazoMaximoGarantiaIdonea.invalid">
              {{ 'PRODUCTOMONTO.LBL_PLAXOMAXIMOGARANTIA' | translate}} {{ 'LBL_REQUERIDO' | translate}}
            </div>
          </div>
        </div>
      </div>

      <div class="grid form-footer-buttons">
        <div class="form-group col-12">
          <div *ngIf="!guardando">
            <button icon="fa fa-plus" label="{{'BTN_AGREGAR' | translate }}"
                    type="submit"
                    pButton></button>
          </div>
          <div *ngIf="guardando">
            <i class="fa fa-refresh fa-spin fa-2x fa-fw"></i><br>
            <span>{{'LBL_GUARDANDO' | translate }}</span>
          </div>
        </div>
      </div>
    </form>

    <div class="grid">
      <div class="col-12 md:col-12 lg:col-12">
        <p-table [columns]="columnas" [loading]="guardando" #dtpromonto
                 [value]="lisProductosMontos" selectionMode="single" dataKey="idProductoMonto"
                 [paginator]="true" [rows]="10"  paginatorPosition="bottom">
          <ng-template pTemplate="header" let-columns>
            <tr>
              <th *ngFor="let col of columns" [pSortableColumn]="col.field" [pSortableColumnDisabled]="!col.sort" class="text-center">
                {{col.header}}
                <p-sortIcon [field]="col.field" *ngIf="col.sort"></p-sortIcon>
              </th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-row let-i="rowIndex">
            <tr [pSelectableRow]="row">
              <td>{{row.montoMinimo}} - {{row.montoMaximo}}</td>
              <td>{{row.plazoMaximo}}</td>
              <td>{{row.plazoMaximoGarantiaIdonea}}</td>
              <td class="text-center">
                <p-checkbox [(ngModel)]="row.indicadorAnalizamos" binary="true" disabled="true"></p-checkbox>
              </td>
              <td class="text-center">
                <p-checkbox [(ngModel)]="row.indicadorFlujoDigital" binary="true" disabled="true"></p-checkbox>
              </td>
              <td class="text-center">
                <div class="btn-group" role="group">
                  <button type="button" class="p-button p-button-success btn" icon="fa fa-trash" data-toggle="tooltip"
                          title="{{'BTN_INHABILITAR' | translate}}" pButton *ngIf="row.indicadorEliminar"
                          (click)="inhabilitar(row)"></button>
                </div>
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage" let-columns>
            <tr>
              <td [attr.colspan]="columns.length" class="text-center">
                {{ 'MSG_NOHAYREGISTROS' | translate}}
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>
  </p-panel>
</div>


<p-confirmDialog #cd key="montos">
  <ng-template pTemplate="footer">
    <button type="button" pButton icon="fa fa-close" label="{{ 'LBL_NO' | translate }}" (click)="cd.reject()"></button>
    <button type="button" pButton icon="fa fa-check" label="{{ 'LBL_SI' | translate }}" (click)="cd.accept()"></button>
  </ng-template>
</p-confirmDialog>
